import NavbarItem from "./navbarItem";
import accessRules from '../../_helpers/accessRules';

module.exports = Object.freeze([
    new NavbarItem("User Maintenance", "main.user", null, accessRules.USER_MAINTENANCE),
  ])



// WEBPACK FOOTER //
// ./client/app/common/navbar/navbarItems.js